export enum CallType {
  Bill = 'bill',
  Waiter = 'waiter',
}
